
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / menu-kebab Copy 4","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.205 18.991a9.711 9.711 0 01-2.955-6.715V12a9.753 9.753 0 019.473-9.75H12a9.751 9.751 0 019.75 9.473v.276a9.751 9.751 0 01-9.474 9.751H12a9.7 9.7 0 01-6.795-2.759zM11.757 3.75a8.247 8.247 0 00-8.007 8.239v.255a8.245 8.245 0 008.239 8.006h.255a8.245 8.245 0 008.006-8.24v-.254A8.25 8.25 0 0012 3.75zm3.119 8.253a1.122 1.122 0 011-1.125l.123-.007.122.007a1.125 1.125 0 11-1.246 1.125zm-4 0a1.122 1.122 0 011-1.125l.122-.007.122.007a1.125 1.125 0 11-1.244 1.129zm-4 0a1.122 1.122 0 011-1.125l.123-.007.122.007a1.125 1.125 0 11-1.245 1.129z","fill":"current-color"}})])
          )
        }
      }
    